export const SPORTSMEN_URL_PART = 'sportsmen'
